// Prezzo come testo, nella forma della lingua (2026-09-16, con lo spagnolo).
// In italiano e inglese il simbolo sta davanti ("€79", "$79"); in spagnolo
// il numero viene prima, poi uno spazio unificatore e il simbolo ("79 €").
// Lo stesso in francese (2026-09-17). In tedesco (2026-09-18) il numero ha
// sempre due decimali con la virgola, poi lo spazio e il simbolo: "49,00 €".
// I file i18n fanno la stessa cosa nelle chiavi con {{symbol}}{{price}}:
// questa funzione serve dove il prezzo viene composto nel codice.
export function prezzoTesto(symbol, amount, lingua) {
  if (amount == null || symbol == null) return '';
  if (lingua === 'de') {
    const n = Number(amount);
    const testo = Number.isFinite(n) ? n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : String(amount);
    return `${testo}\u00a0${symbol}`;
  }
  return (lingua === 'es' || lingua === 'fr') ? `${amount}\u00a0${symbol}` : `${symbol}${amount}`;
}
